import { memo } from 'react';

import Footer from 'components/layouts/Footer';

// Revamp
import HeaderV2 from '_revamp/molecules/navbar';
import Sidebar from './sidebar';

function Main(props) {
  return (
    <>
      <div className="wrapper">
        <Sidebar loginType={props?.loginType || 'user'} bo={props.bo} />
        <div className="main">
          <HeaderV2 loginType={props?.loginType || 'user'} />
          <div className="v_body">{props.children}</div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default memo(Main);
